module.exports = __webpack_public_path__ + "static/media/Illustration-03@3x.59c3f1a5.png";